import Gallery from '@jetshop/ui/Gallery/Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React, { useContext, useState } from 'react';
import styled from 'react-emotion';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from '@jetshop/ui/Image';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import { ReactComponent as Close } from '../../../svg/Cross.svg';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  z-index: 0;
  & > div {
    z-index: 0;
    ${({ theme }) => theme.below.md} {
      z-index: auto;
    }
  }
  .image-gallery-thumbnails-wrapper {
    ${({ theme }) => theme.below.md} {
      display: none;
    }
  }
  .image-gallery-thumbnail {
    &.active {
      border: 1px solid black;
    }
  }
`;

const SliderWrapper = styled('div')`
  &.fullscreen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background: white;

    .image-item {
      > div {
        padding: 0 !important;
        height: 100vh !important;
      }
    }
  }

  &.mtb {
    height: 100%;
    div {
      height: 100%;
    }
    .group {
      .group-inner {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0;

        &.image-length-1 {
          display: block;
          padding: 40px;
          .image-item {
            border: 0 !important;
          }
          img {
            object-fit: contain !important;
          }
        }
        &.image-length-2 {
          img {
            object-fit: contain !important;
          }
          .image-item:first-child {
            grid-column: 1 / 2;
            grid-row: 1 / 3;
          }
          .image-item:first-child + .image-item {
            grid-column: 2 / 3;
            grid-row: 1 / 3;
          }
        }

        .image-item {
          > div {
            padding: 0 !important;
            height: 100% !important;
            width: 100% !important;
          }
        }
      }
    }
  }

  &.ski {
    height: 100%;
    div {
      height: 100%;
    }
    .group {
      .group-inner {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0;

        &.image-length-1 {
          display: block;
          padding: 40px;
          .image-item {
            border: 0 !important;
          }
          img {
            object-fit: contain !important;
          }
        }
        &.image-length-2 {
          .image-item:first-child + .image-item {
            grid-column: 2 / 3;
            grid-row: 1 / 3;
          }
        }

        .image-item {
          > div {
            padding: 0 !important;
            height: 100% !important;
            width: 100% !important;
          }
        }
        > .image-item:first-child {
          grid-column: 1 / 1;
          grid-row: 1 / 3;
          border-right: 1px solid #f3f3f3;

          + .image-item {
            grid-column: 2 / 3;
            grid-row: 1 / 1;
            border-bottom: 1px solid #f3f3f3;
          }
        }
      }
    }
  }

  .video-wrapper {
    position: relative;
  }
  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
const Arrow = styled('button')`
  background: black;
  border-radius: 100%;
  border: 0;
  height: 30px;
  width: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;

  &.slick-next {
    transform: rotate(0deg);
    right: 10px;
    left: auto;
    z-index: 1;
  }
  &.slick-prev {
    transform: rotate(180deg);
    right: auto;
    left: 10px;
    z-index: 1;
  }
  &:focus {
    outline: none;
  }

  svg {
    width: 40px;
    height: auto;
  }
`;

const Dots = styled('ul')`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 20px;
  position: absolute;
  left: 0;
  right: 0;
`;
const Dot = styled('button')`
  background: black;
  border: 0;
  height: 15px;
  width: 15px;
  border-radius: 100%;
  margin: 0 5px;
  &:focus {
    outline: none;
  }

  .slick-active & {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const FullscreenClose = styled('div')`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  svg {
    width: 24px;
    height: 24px;
    g,
    use {
      fill: black;
      stroke: black;
    }
  }
`;

const CustomArrow = (props) => {
  const { className, onClick } = props;
  return (
    <Arrow className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fal', 'angle-right']} />
    </Arrow>
  );
};

function groupBy(arr, n) {
  var group = [];
  for (var i = 0, end = arr.length / n; i < end; ++i)
    group.push(arr.slice(i * n, (i + 1) * n));
  return group;
}

export default function ImageContainer({
  images,
  badges,
  variant,
  youtube,
  ...rest
}) {
  const { selectedChannel } = useContext(ChannelContext);
  const galleryRef = React.createRef();
  const [fullscreen, setFullscreen] = useState(false);
  const [initialImage, setInitialImage] = useState(0);
  const [standardImage, setStandardImage] = useState(0);
  // Enable switching gallery to image of selected variant
  // useSwitchToVariantImage({
  //   galleryImages: images,
  //   galleryRef,
  //   variant,
  // });

  const imageAspect = '3:4';
  const imageSizes = [1 / 4, 1 / 3, 3 / 4, 3 / 4];

  let withYoutube = [];
  if (youtube) {
    for (let i = 0; i < images.length; i++) {
      withYoutube.push(images[i]);
    }
    withYoutube.splice(1, 0, { youtube: true, url: youtube.stringValue });
  }

  let newImages = null;
  if (selectedChannel.name === 'SKI') {
    if (youtube) {
      newImages = groupBy(withYoutube, 3);
    } else {
      newImages = groupBy(images, 3);
    }
  } else {
    if (youtube) {
      newImages = groupBy(withYoutube, 4);
    } else {
      newImages = groupBy(images, 4);
    }
  }

  function getImagePosition(url) {
    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      if (image.url === url) {
        return images.findIndex((x) => x.url === url);
      }
    }
  }

  var fullscreenSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />,
    appendDots: (dots) => <Dots>{dots}</Dots>,
    customPaging: (i) => <Dot />,
    initialSlide: initialImage ? initialImage : 0,
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />,
    appendDots: (dots) => <Dots>{dots}</Dots>,
    customPaging: (i) => <Dot />,
    initialSlide: standardImage ? standardImage : 0,
  };
  return (
    <>
      <Above breakpoint="md">
        <>
          {fullscreen ? (
            <>
              <FullscreenClose onClick={() => setFullscreen(false)}>
                <Close />
              </FullscreenClose>

              <SliderWrapper className={fullscreen ? 'fullscreen' : ''}>
                <Slider {...fullscreenSettings}>
                  {images.map((image, i) => (
                    <div
                      key={i}
                      href={image.url}
                      target="_blank"
                      className="image-item"
                    >
                      <Image
                        gravity="centre"
                        key={i}
                        aspect={'6:4'}
                        src={image.url}
                        sizes={imageSizes}
                      />
                    </div>
                  ))}
                </Slider>
              </SliderWrapper>
            </>
          ) : (
            <SliderWrapper
              className={
                'image-length-' +
                images.length +
                ' ' +
                selectedChannel?.name?.toLowerCase()
              }
            >
              <Slider {...settings}>
                {newImages.map((group, index) => (
                  <div
                    className={'group ' + 'image-length-' + group.length}
                    key={index}
                  >
                    <div
                      className={
                        'group-inner ' + 'image-length-' + group.length
                      }
                    >
                      {group.map((image, i) => (
                        <React.Fragment key={i}>
                          {image.youtube ? (
                            <div className="video-wrapper">
                              <iframe
                                title={image.url}
                                width="100%"
                                height="auto"
                                src={
                                  'https://www.youtube.com/embed/' +
                                  image.url.split('?v=')[1] +
                                  '?mode=opaque&rel=0&autohide=1&showinfo=0&wmode=transparent&modestbranding=0&showinfo=0&rel=0'
                                }
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              />
                            </div>
                          ) : (
                            <div
                              key={i}
                              href={image.url}
                              target="_blank"
                              className="image-item"
                            >
                              <Image
                                gravity="centre"
                                key={i}
                                aspect={'6:4'}
                                src={image.url}
                                sizes={imageSizes}
                                onClick={() => (
                                  setFullscreen(true),
                                  setInitialImage(getImagePosition(image.url)),
                                  setStandardImage(index)
                                )}
                              />
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </Slider>
            </SliderWrapper>
          )}
        </>
      </Above>
      <Below breakpoint="md">
        <Wrapper {...rest}>
          <Gallery aspect={'6:4'} images={images} galleryRef={galleryRef}>
            <Badges badges={badges} />
          </Gallery>
        </Wrapper>
      </Below>
    </>
  );
}
